<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/reserve">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="detail_content">
            <div class="detail_label">
              {{ nameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputNameUpdate"
            />
          </div>
          <div class="detail_content">
            <div class="detail_label">
              {{ dateLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <datepicker
              placeholder="Select Date"
              :config="reserve_config"
              :locale="ja"
              id="reserve_date"
              value=""
              @on-change="customFormatter"
              class="reserve_datepicker start_date_time"
            >
            </datepicker>
          </div>
          <div class="detail_content">
            <div class="detail_label">
              {{ fileLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <form id="excel_file">
              <input
                id="select_file_button"
                type="file"
                class="upload_button"
                accept=".xlsx"
                @change="selectFile"
              />
              <label class="select_file_area" for="select_file_button">
                <div class="select_file_button">
                  {{ selectFileLabel }}
                </div>
                <span class="select_file_name">
                  {{ selectFileName }}
                </span>
              </label>
            </form>
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addReserve"> </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import japanese from 'flatpickr/dist/l10n/ja.js'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      nameLabel: '予約名',
      dateLabel: '予約日時',
      fileLabel: 'Excelファイル',
      selectFileLabel: 'ファイルを選択',
      selectFileName: '選択されていません',
      router: '/reserve',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      reserveFile: {
        name: '',
        time: '',
        fileName: '',
        file: ''
      },
      ja: japanese,
      reserve_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        minDate: this.minDate(),
        maxDate: this.maxDate(),
        defaultHour: 0,
        defaultMinute: 0,
        minuteIncrement: 1
      }
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  components: {
    completeModalWindow,
    loadingModalWindow,
    datepicker,
    addModalWindow
  },
  methods: {
    pickerFormatDate(localDate) {
      return `${localDate.getFullYear()}-${(localDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${localDate
        .getDate()
        .toString()
        .padStart(2, '0')} ${localDate
        .getHours()
        .toString()
        .padStart(2, '0')}:${localDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}:${localDate
        .getSeconds()
        .toString()
        .padStart(2, '0')}`
    },
    minDate() {
      var localDate = new Date()
      localDate.setMilliseconds(0)
      localDate.setSeconds(0)
      localDate.setHours(0)
      localDate.setMinutes(0)
      return this.pickerFormatDate(localDate)
    },
    maxDate() {
      var localDate = new Date()
      localDate.setMilliseconds(0)
      localDate.setSeconds(0)
      localDate.setHours(23)
      localDate.setMinutes(59)
      localDate.setDate(localDate.getDate() + 180)
      return this.pickerFormatDate(localDate)
    },
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      return year + '/' + month + '/' + day
    },
    inputNameUpdate(e) {
      this.reserveFile.name = e.target.value
    },
    selectFile(e) {
      const file = e.target.files[0]
      const limit = 600 * 1024 * 1024
      if (file.size < limit) {
        this.showloadingModal = true
        var fileReader = new FileReader()
        fileReader.onload = () => {
          const datas = fileReader.result.split(',')
          if (datas.length === 2) {
            this.reserveFile.fileName = file.name
            this.reserveFile.file = datas[1]
            this.showloadingModal = false
            this.selectFileName = file.name
          } else {
            this.showloadingModal = false
            // エラー表示
          }
        }
        fileReader.readAsDataURL(file)
      } else {
        // エラー表示
      }
      document.getElementById('excel_file').reset()
    },
    async addReserve(e) {
      const reserveDate = document.getElementById('reserve_date').value
      this.reserveFile.time = new Date(reserveDate).getTime()
      this.showloadingModal = true
      try {
        await this.$store.dispatch('reserve/addReserve', this.reserveFile)
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord =
          '追加しました。<br/>検証結果はリストから予約項目を選択し<br/>詳細画面の実行状況をご確認ください。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_700001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          switch (errorMessage) {
            case 'MSGCRC0209':
            case 'MSGCRC0210':
            case 'MSGCRC0211':
            case 'MSGCRC0212':
            case 'MSGCRC0213':
            case 'MSGCRC0214':
            case 'MSGCRC0227':
            case 'MSGCRC0228':
            case 'MSGCRC0229':
            case 'MSGCRC0230':
            case 'MSGCRC0264':
            case 'MSGCRC0269':
            case 'MSGCRC0270':
            case 'MSGCRC0271':
            case 'MSGCRC0272':
              this.failureWord =
                this.errorMsg[errorMessage].name +
                this.errorMsg[errorMessage].value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = errorMessage + ' '
              break
            default:
              const infos = errorMessage.split(',')
              if (infos.length > 1) {
                this.failureWord = this.makeErrorText(eventNumber, errorMessage)
                reason = infos[0] + ' '
              } else {
                this.failureWord =
                  this.errorMsg.MSGCRC0215.name +
                  this.errorMsg.MSGCRC0215.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
                reason = 'MSGCRC0215 '
              }
              break
          }
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0215'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0215.name +
            this.errorMsg.MSGCRC0215.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    makeErrorText(eventNumber, errorDetail) {
      const infos = errorDetail.split(',')
      const errorCode = infos[0]
      const errorSheet = infos.length >= 2 ? infos[1] : ''
      const errorLine = infos.length >= 3 ? infos[2] : ''
      let errorText = ''
      if (this.errorMsg[errorCode] !== undefined) {
        errorText += this.errorMsg[errorCode].name
        if (this.errorMsg[errorCode].beforeValue) {
          errorText += this.errorMsg[errorCode].beforeValue
        }
      } else {
        errorText += errorCode
      }
      errorText += `${errorSheet !== '' ? errorSheet + 'シート ' : ''}`
      errorText += `${
        errorLine !== '' && errorLine !== undefined ? errorLine : ''
      }`
      if (this.errorMsg[errorCode] !== undefined) {
        if (this.errorMsg[errorCode].afterValue) {
          errorText += this.errorMsg[errorCode].afterValue
        } else if (this.errorMsg[errorCode].value) {
          errorText += this.errorMsg[errorCode].value
        }
      }
      return errorText + 'エラーコード：{' + eventNumber + '}'
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/reserve')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    }
  }
}
</script>

<style scoped>
.reserve_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
}
.upload_button {
  display: none;
}
.select_file_area {
  display: flex;
}
.select_file_button {
  color: white;
  background: #00afa8;
  font-size: 14px;
  border: 0;
  border-radius: 3px;
  padding: 8px 16px;
  text-align: center;
  min-width: 106px;
  max-height: 20px;
}
.select_file_name {
  display: inline;
  color: black;
  font-size: 14px;
  padding: 4px 16px;
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/reserve/reserveAdd.vue